import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import IconTime from "../../assets/icon-time.svg";
import PointingArrow from "../../assets/pointing-arrow.svg";
import { Link, withRouter } from "react-router-dom";
import { PATHS, ISSUE_STATUS } from "../../constant";
import { get } from "lodash";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  dateFormat,
  scrollToPosition,
  getColor,
  dayAgo,
  transformProjectCategoryId
} from "../../helper";
import { toolttipDisplayMessage } from "./helper";
import { ReadMore, RedirectUser } from "../reusableComponent";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import { ReadMoreContent } from "../reusableComponent/readMore/readMoreContent";

class ForwardToTeamChilds extends Component {
  redirectPage = (e, issueId) => {
    const { history, issueDetails } = this.props;
    e.preventDefault();
    history.push({
      pathname: PATHS.ISSUE_DETAIL,
      search: `?issueId=${issueId}&&projectId=${get(
        issueDetails,
        "project.id"
      ) || get(issueDetails, "projectId")}`
    });
    window.location.reload();
  };

  createTemplate = () => {
    const { childs, issueDetails, createdBy } = this.props;
    const { id: parentId } = issueDetails || {};
    const isChild = () => {
      // console.log("from isChild function", parentId);
    };
    return (childs || []).map((value, idx) => {
      return (
        <>
          <div className="forward-to-team-heading">
            <h3 className="margin-top">
              Forwarded to <span>{value.assigneeGroup}</span>
              <br />
              <div className="pt-2">
                <img src={PointingArrow} />{" "}
                <span className="creator-text">by</span>{" "}
                <RedirectUser
                  title={value.issueForwardedByName}
                  id={value.issueForwardedById}
                  isIssueForwarded={true}
                  isMilestonePPDetail={true}
                />{" "}
                <span className="creator-text">
                  on {dateFormat(get(value, "createdDate", null))}
                </span>
              </div>
            </h3>
            <div className="flex-right">
              <OverlayTrigger
                defaultShow={false}
                placement="top"
                overlay={
                  <Tooltip className="issues-status-tooltip">
                    {toolttipDisplayMessage(get(value, "status", "NA"))}
                  </Tooltip>
                }
              >
                <div>
                  <Button
                    className={`btn-extra-small animated flipInX ${getColor(
                      get(value, "status", "NA")
                    )} unClickable`}
                  >
                    {get(value, "status", "NA")}
                  </Button>
                </div>
              </OverlayTrigger>
              <div className="issue-list-status assigned-to-status">
                <div className="issue-list-status-inner padding-top">
                  <div className="issue-assignee">
                    <b className="animated fadeInRight">
                      {get(value, "status") === ISSUE_STATUS.REJECT ||
                      get(value, "status") === ISSUE_STATUS.RESOLVED ||
                      get(value, "status") === ISSUE_STATUS.REJECTED ||
                      get(value, "status") === ISSUE_STATUS.HOLD ||
                      get(value, "status") === ISSUE_STATUS.reject ||
                      get(value, "status") === ISSUE_STATUS.resolved ||
                      get(value, "status") === ISSUE_STATUS.hold ||
                      get(value, "status") === ISSUE_STATUS["On Hold"] ? (
                        get(value, "status") === ISSUE_STATUS.REJECT ||
                        get(value, "status") === ISSUE_STATUS.reject ||
                        get(value, "status") === ISSUE_STATUS.REJECTED ||
                        get(issueDetails, "status") === ISSUE_STATUS.REJECT ||
                        get(issueDetails, "status") === ISSUE_STATUS.reject ||
                        get(issueDetails, "status") ===
                          ISSUE_STATUS.REJECTED ? (
                          <>
                            <span className="issue-assignee-title">
                              Rejected by{" "}
                            </span>
                            <b>{get(value, "issueStatusChangeGroup")}</b>
                          </>
                        ) : get(value, "status") === ISSUE_STATUS.RESOLVED ||
                          get(issueDetails, "status") ===
                            ISSUE_STATUS.resolved ? (
                          <>
                            <span className="issue-assignee-title">
                              Resolved by{" "}
                            </span>
                            <b>{get(value, "issueStatusChangeGroup")}</b>
                          </>
                        ) : (
                          <>
                            <span className="issue-assignee-title">
                              On Hold by{" "}
                            </span>
                            <b> {get(value, "issueStatusChangeGroup")}</b>
                          </>
                        )
                      ) : (
                        <>
                          <span className="issue-assignee-title">
                            Assigned to{" "}
                          </span>
                          <b>{get(value, "assigneeGroup")}</b>
                        </>
                      )}
                    </b>

                    {/* Assigned to <b>{get(value, "assigneeGroup", "NA")}</b> */}
                  </div>
                  <div className="issue-assign-date">
                    <Image src={IconTime} alt="Time" />
                    <span>
                      {get(value, "status") === ISSUE_STATUS.REJECT ||
                      get(value, "status") === ISSUE_STATUS.RESOLVED ||
                      get(value, "status") === ISSUE_STATUS.HOLD ||
                      get(value, "status") === ISSUE_STATUS.reject ||
                      get(value, "status") === ISSUE_STATUS.resolved ||
                      get(value, "status") === ISSUE_STATUS.REJECTED ||
                      get(value, "status") === ISSUE_STATUS.hold ||
                      get(value, "status") === ISSUE_STATUS["On Hold"]
                        ? `on ${dateFormat(
                            get(value, "issueStatusChangeDate")
                          )}`
                        : get(value, "lastAssigneeDate")
                        ? dayAgo(get(value, "lastAssigneeDate"))
                        : dayAgo(get(value, "createdDate"))}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="select-issue-content decision-issue-content"
            key={`forward-to-child--${value.recipientGroup}`}
          >
            <div className="issue-list-middle">
              <div className="issue-list-desc-wrapper">
                <div className="issue-actions-wrapper">
                  <div className="issue-list-header child-issues margin-top">
                    <span className="issue-number">
                      Issue{" "}
                      <b>
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `?issueId=${value.id}&&projectId=${get(
                              issueDetails,
                              "project.id"
                            ) || get(issueDetails, "projectId")}`
                          }}
                          //onClick={isChild()}
                          //parentId = {parentId}
                        >
                          {/**CR 99 Changes Starts */}#
                          {`${get(issueDetails, "project.id") ||
                            get(issueDetails, "projectId")}-${parentId}/${
                            value.id
                          }`}
                          {/**CR 99 Changes Ends */}
                        </Link>
                      </b>
                      {/**CR 289 Changes Starts-Yajnadutta */}
                      {/* {get(issueDetails, "escalationLevelName", "NA") ==
                      null ? null : (
                        <EscalationLevelModal
                          IssueId={value.id}
                          EscalationName={get(
                            issueDetails,
                            "escalationLevelName",
                            "NA"
                          )}
                          pragatiDetailPage={true}
                          pragatiDetailPageCss={true}
                        />
                      )} */}
                      {/**CR 289 Changes End-Yajnadutta */}
                    </span>

                    <h2 className="issue-category"> </h2>
                  </div>
                  <h2 className="main-heading">{get(value, "title", "NA")}</h2>
                  <h4 className="small-heading">
                    <span>
                      Recipient{" "}
                      {transformProjectCategoryId(
                        get(value, "recipientGroupCategory", "NA")
                      )}
                      :
                    </span>
                    <div> {get(value, "recipientGroup", "NA")}</div>
                  </h4>
                  {/* <b className="issue-title">{get(value, "title", "NA")}</b>*/}
                  <div className="issue-list-desc">
                    {/* <ReadMore
                      // length={230}
                      content={get(value, "description", "NA")}
                    /> */}
                    <ReadMoreContent
                      //clamp={2}
                      content={get(value, "description", "NA")}
                    />
                    {/* <span
                      className="read-more"
                      onClick={e => {
                        this.redirectPage(e, get(value, "id"));
                      }}
                    >
                      Read More
                    </span> */}
                  </div>
                </div>
              </div>
              <div className="forward-to-team decision-issue-content issue-list-desc-wrapper">
                <div className="forward-to-team-right">
                  <div className="forward-to-team-right-bottom">
                    <div
                      className={`decision-created-on ${value.creatorVerified &&
                        "verified-user"} `}
                    >
                      <RedirectUser
                        title={
                          get(issueDetails, "creatorName") ||
                          get(issueDetails, "issueCreatorName") ||
                          createdBy.name
                        }
                        id={
                          issueDetails.hasOwnProperty("project") ||
                          issueDetails.previousCreatedBy !== null
                            ? get(issueDetails, "createdById") ||
                              get(issueDetails, "previousCreatedBy.id")
                            : createdBy !== null
                            ? createdBy.id
                            : null
                        }
                      />
                    </div>
                    <span className="seperator">|</span>
                    <div className={"created-date"}>
                      Verified on{" "}
                      {dateFormat(get(issueDetails, "verificationDate", null))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    });
  };

  render() {
    return this.createTemplate();
  }
}

export default withRouter(ForwardToTeamChilds);
